module.exports = __webpack_public_path__ + "img/product_recomed_bg.f5310953.png";